import http from "@/request/index.ts";

export default class ConsultApi {
  /**
   * 咨询保存接口
   */
  static async saveConsult(data = {}) {
    const payload = {
      contact: data?.contact ?? "",
      contactPhone: data?.contactPhone ?? "",
      deptName: data?.deptName ?? "",
      askQuestions: data?.askQuestions ?? "",
    };
    let res = await http.post("/program/save", payload);
    if (!res || res.code !== 200) {
      const error = new Error(res?.msg || "提交失败，请稍后再试");
      error.code = res?.code;
      throw error;
    }
    return res.data;
  }
}
